<template>
    <div class="container" v-if="actual">
        <div class="kt-grid  kt-wizard-v1 kt-wizard-v1--white"  >
            <div class="kt-wizard-v1__nav">
                <div class="kt-wizard-v1__nav-items">
                    <a class="kt-wizard-v1__nav-item"
                       href="#"
                       data-ktwizard-type="step"
                       v-on:click="cambiarPaso(paso)"
                       :data-ktwizard-state="paso.numero<=actual.numero ? 'current': 'pending'"
                       v-for="paso in pasos" :key="paso.numero">
                        <div class="kt-wizard-v1__nav-body">
                            <div class="kt-wizard-v1__nav-icon">
                                <i :class="paso.icono"></i>
                            </div>
                            <div class="kt-wizard-v1__nav-label">{{paso.numero}}) {{paso.titulo}}</div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <titulo v-if="actual"></titulo>
    </div>
</template>

<script>
    import titulo from "./wizard-titulo";
    import constantes from "../constantes";
    export default {
        data:()=>({
            pasos:constantes.Constantes.pasos,
            mostrar:false,
        }),
        components:{
            titulo
        },
        computed:{
            actual:function(){
                if(this.$store.getters.getPasoActual)
                    return this.$store.getters.getPasoActual;
                else
                    return false;
            }
        },
        methods:{
            cambiarPaso:function(paso){
                if(paso.numero<this.$store.getters.getPasoActual.numero) {
                    this.$store.commit('setActual', paso.numero);
                    this.$router.push({name: 'p' + paso.numero});
                }else {
                    if (paso.numero !== this.$store.getters.getPasoActual.numero) {
                        this.$toast.warning(`Complete primero el paso ${paso.numero - 1}`, 'Hey');
                    }
                }

            }
        },
        mounted() {
            if(this.$router.currentRoute==="Home")
                this.mostrar=false;
        }
    }
</script>

<style scoped>

</style>
